import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Select from "primevue/select";
import FloatLabel from "primevue/floatlabel";
import InputOtp from "primevue/inputotp";
import Message from "primevue/message";
import Textarea from "primevue/textarea";
import Dialog from "primevue/dialog";
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Panel from 'primevue/panel';
import ToggleSwitch from 'primevue/toggleswitch';
import CheckboxGroup from 'primevue/checkboxgroup';
import Sidebar from "primevue/sidebar";
import RadioButton from "primevue/radiobutton";
import DatePicker from "primevue/datepicker";
import Checkbox from "primevue/checkbox";
import ProgressBar from "primevue/progressbar";
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import Skeleton from "primevue/skeleton";
import Popover from 'primevue/popover';
import Tooltip from 'primevue/tooltip';
import ProgressSpinner from 'primevue/progressspinner';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';


export default {
  install: (app) => {
    app.directive('tooltip', Tooltip);
    app.component("Button", Button);
    app.component("InputText", InputText);
    app.component("Select", Select);
    app.component("FloatLabel", FloatLabel);
    app.component("Message", Message);
    app.component("Textarea", Textarea);
    app.component("InputOtp", InputOtp);
    app.component("Dialog", Dialog);
    app.component("Avatar", Avatar);
    app.component("AvatarGroup", AvatarGroup);
    app.component("Panel", Panel);
    app.component("ToggleSwitch", ToggleSwitch);
    app.component("Checkbox", Checkbox);
    app.component("CheckboxGroup", CheckboxGroup);
    app.component("Sidebar", Sidebar);
    app.component("RadioButton", RadioButton);
    app.component("DatePicker", DatePicker);
    app.component("ProgressBar", ProgressBar);
    app.component("Accordion",Accordion)
    app.component("AccordionPanel",AccordionPanel)
    app.component("AccordionHeader",AccordionHeader)
    app.component("AccordionContent",AccordionContent)
    app.component("Skeleton", Skeleton);
    app.component("Popover", Popover);
    app.component("ProgressSpinner", ProgressSpinner);
    app.component("Tabs", Tabs);
    app.component("TabList", TabList);
    app.component("Tab", Tab);
    app.component("TabPanels", TabPanels);
    app.component("TabPanel", TabPanel);
  },
};
